
import until from "./until.js"
import {ajax,uploadImg,getRequestUrl,formatData} from "./request.js"
import router from '@/router' // 引入router
import vue from 'vue'
import store from 'store'
import roomColumn from "./roomColumn.js";
import group from "./group";


vue.config.productionTip =false



function globalRequestMeth() {
  return vue.prototype.$selfGlobal.$globalRequestMeth;
}


// 登录
function login(data) {
  return ajax('post', getRequestUrl('/api/Login/index'), data)
}

// 退出登录
function loginOut() {
  return ajax('post', getRequestUrl('/api/Login/logout'), {});
}

// 操作密码
function checkAdminPwd(data) {
  return ajax('post', getRequestUrl('/api/Admin/checkAdminPwd'), data);
}

function checkOperateUser(data, method) {
  return ajax('post', getRequestUrl('/api/CommonHelper/checkOperateUser'), data, {
    method,
  });
}

// 导出表格
function exportData(arr) {
  // let url = baseUrl + '/api/Service/servicekProblemListExport?' + arr.join('&')
  let url = getRequestUrl('/api/Service/servicekProblemListExport') + '&' + arr.join('&');
  window.open(url, '_blank');
  // window.location.href = url;
}

function exportExtData(arr, reqUrl) {
  let url = getRequestUrl(reqUrl) + '&' + arr.join('&');
  window.open(url, '_blank');
}

// 上传图片
function upload(data) {
  return uploadImg(getRequestUrl('/api/UploadFile/uploadPicture'), data)
}

function uploadVideo(data) {
  return uploadImg(getRequestUrl('/api/UploadFile/uploadvideo'), data)
}

// 用户查询
function usersSearch(data, method) {
  return ajax('post', getRequestUrl('/api/Member/findMember'), data, {
    method,
  })
}
// 用户管理-解除12小时锁定
function UnblockInformation(data, method) {
  return ajax('post', getRequestUrl('/api/Member/UnblockInformation'), data, {
    method,
  })
}

// 用户查询 -- 更多ip
function memberMoreIp(data, method) {
  return ajax('post', getRequestUrl('/api/Member/memberMoreIp'), data, {
    method,
  }).then(data => {
    return formatData.formatListData(data);
  });
}

// 用户查询 -- 修改靓号
function saveUserNo(data, method) {
  return ajax('post', getRequestUrl('/api/Member/saveUserNo'), data, {
    method,
  });
}

// 用户查询 -- 修改昵称
function saveNickname(data, method) {
  return ajax('post', getRequestUrl('/api/Member/saveNickname'), data, {
    method,
  });
}

// 用户查询 -- 修改头像
function saveAvatar(data, method) {
  return ajax('post', getRequestUrl('/api/Member/saveAvatar'), data, {
    method,
  });
}

// 用户查询 -- 封禁id
function memberBannedId(data, method) {
  return ajax('post', getRequestUrl('/api/Member/bannedId'), data, {
    method,
  });
}

// 用户查询 -- 封禁设备
function memberBannedDevice(data, method) {
  return ajax('post', getRequestUrl('/api/Member/bannedDevice'), data, {
    method,
  });
}

// 用户查询 -- 解禁设备
function memberNoBannedDevice(data, method) {
  return ajax('post', getRequestUrl('/api/Member/noBannedDevice'), data, {
    method,
  });
}

// 用户查询 -- 解禁id
function memberUnBannedId(data, method) {
  return ajax('post', getRequestUrl('/api/Member/unBannedId'), data, {
    method,
  });
}

// 用户查询 -- 道具列表
function memberFindPropList(data, method) {
  return ajax('post', getRequestUrl('/api/Member/findPropList'), data, {
    method,
  });
}

// 用户查询 -- 新增道具
function memberCreateProp(data, method) {
  return ajax('post', getRequestUrl('/api/Member/createProp'), data, {
    method,
  });
}

// 用户查询 -- 新增vip道具接口
function memberCreateVip(data, method) {
  return ajax('post', getRequestUrl('/api/Member/createVip'), data, {
    method,
  });
}

// 用户查询 -- svip操作记录
function BannedSvipList(data, method) {
  return ajax('post', getRequestUrl('/api/Member/BannedSvipList'), data, {
    method,
  });
}

// 用户查询--明细列表--封禁所选账号及其设备
function selectBlockIdAndDevice(data, method) {
  return ajax('post', getRequestUrl('/api/Member/selectBlockIdAndDevice'), data, {
    method,
  });
}

// 用户查询 -- 封禁召唤接口
function gatherBan(data, method) {
  return ajax('post', getRequestUrl('/api/Member/gatherBan'), data, {
    method,
  });
}
// 用户查询 -- 解除召唤接口
function gatherUnblock(data, method) {
  return ajax('post', getRequestUrl('/api/Member/gatherUnblock'), data, {
    method,
  });
}
// 用户查询 -- 解除召唤接口
function freezeRechargeList(data, method) {
  return ajax('post', getRequestUrl('/api/Member/freezeRechargeList'), data, {
    method,
  });
}
// 用户查询 -- 封禁详情接口
function getbanAccountList(data, method) {
  return ajax('post', getRequestUrl('/api/Member/banAccountList'), data, {
    method,
  });
}

// 用户查询 -- 运营备忘列表
function uidMemoList(data, method) {
  return ajax('post', getRequestUrl('/api/Member/uidMemoList'), data, {
    method,
  });
}
// 用户查询 -- 添加备忘接口
function uidMemoAdd(data, method) {
  return ajax('post', getRequestUrl('/api/Member/uidMemoAdd'), data, {
    method,
  });
}

// 用户查询 -- 删除用户道具
function memberDeleteHoldProp(data, method) {
  return ajax('post', getRequestUrl('/api/Member/deleteHoldProp'), data, {
    method,
  });
}

// 用户查询--删除用户背包卡券等
function deleteBackpackProp(data, method) {
  return ajax('post', getRequestUrl('/api/Member/deleteBackpackProp'), data, {
    method,
  });
}

// 用户查询--解禁广播
function userUnbanBroadcast(data, method) {
  return ajax('post', getRequestUrl('/api/Member/unbanBroadcast'), data, {
    method,
  });
}
// 用户查询--封禁广播接口
function memberBannedBroadcast(data, method) {
  return ajax('post', getRequestUrl('/api/Member/banBroadcast'), data, {
    method,
  });
}

// 用户查询--封禁广播接口
function memberMorePushId(data, method) {
  return ajax('post', getRequestUrl('/api/Member/memberMorePushId'), data, {
    method,
  });
}

// 用户查询--更新国家
function saveCountry(data, method) {
  return ajax('post', getRequestUrl('/api/Member/saveCountry'), data, {
    method,
  });
}

// 用户查询--系统国家列表
function systemCountryList(data, method) {
  return ajax('post', getRequestUrl('/api/Member/systemCountryList'), data, {
    method,
  }).then(data => {
    return formatData.formatListData(data);
  });
}

// 用户查询--特殊关系接口
function specialList(data, method) {
  return ajax('post', getRequestUrl('/api/Member/specialList'), data, {
    method,
  })
}

// 用户当前所在房间
function nowMemberInroom(data, method) {
  return ajax('post', getRequestUrl('/api/Member/nowMemberInroom'), data, {
    method,
  })
}

// 用户查询 -- 用户封禁操作记录
function memberHistoryList(data, method) {
  return ajax('post', getRequestUrl('/api/Member/serviceHistoryList'), data, {
    method,
  }).then(data => {
    return formatData.formatListData(data);
  });
}

// 用户查询 -- 修改密码
function savePassword(data, method) {
  return ajax('post', getRequestUrl('/api/Member/savePassword'), data, {
    method,
  })
}

// 用户查询 -- 修改手机号
function saveMobile(data, method) {
  return ajax('post', getRequestUrl('/api/Member/saveMobile'), data, {
    method,
  })
}
// 用户查询 -- 修改区号
function editRegion(data, method) {
  return ajax('post', getRequestUrl('/api/Member/editRegion'), data, {
    method,
  })
}

// 用户查询 -- 修改邮箱
function saveEmail(data, method) {
  return ajax('post', getRequestUrl('/api/Member/saveEmail'), data, {
    method,
  })
}

// 用户查询 -- 解除绑定信息
function userUnbind(data, method) {
  return ajax('post', getRequestUrl('/api/Member/userUnbind'), data, {
    method,
  })
}

// 用户查询 -- 重置用户资料
function resetUserInfo(data, method) {
  return ajax('post', getRequestUrl('/api/Member/resetUserInfo'), data, {
    method,
  })
}

// 平台运营数据 -- 退款明细
function refundDetailsList(data, method) {
  return ajax('post', getRequestUrl('/api/Data/refundDetailsList'), data, {
    method,
  }).then(data => {
    return formatData.formatListData(data);
  });
}
// 平台运营数据 -- 退款明细-修改备注
function remarkSet(data, method) {
  return ajax('post', getRequestUrl('/api/Data/remarkSet'), data, {
    method,
  }).then(data => {
    return formatData.formatListData(data);
  });
}
// 平台运营数据 -- 退款明细-还款
function repayment(data, method) {
  return ajax('post', getRequestUrl('/api/Data/repayment'), data, {
    method,
  }).then(data => {
    return formatData.formatListData(data);
  });
}


// 房间查询
function api_room(data, method) {
  return ajax('post', getRequestUrl('/api/room/findRoomDetail'), data, {
    method,
  });
}

// 房间查询--修改昵称
function saveRoomName(data, method) {
  return ajax('post', getRequestUrl('/api/Room/saveRoomName'), data, {
    method,
  });
}

// 房间查询--解绑
function unBannedRoom(data, method) {
  return ajax('post', getRequestUrl('/api/Room/unBannedRoom'), data, {
    method,
  });
}

// 房间查询--修改头像
function saveRoomAvatar(data, method) {
  return ajax('post', getRequestUrl('/api/Room/saveRoomAvatar'), data, {
    method,
  });
}

// 房间查询--封禁房间
function bannedRoom(data, method) {
  return ajax('post', getRequestUrl('/api/Room/bannedRoom'), data, {
    method,
  });
}

// 房间查询--房间黑名单
function roomBlackList(data, method) {
  return ajax('post', getRequestUrl('/api/Room/roomBlackList'), data, {
    method,
  }).then(data => {
    return formatData.formatListData(data);
  });
}

// 房间查询--移除房间黑名单
function removeRoomBlack(data, method) {
  return ajax('post', getRequestUrl('/api/Room/removeRoomBlack'), data, {
    method,
  });
}

// 房间查询--解散申请列表接口
function roomDissolutionApplication(data, method) {
  return ajax('post', getRequestUrl('/api/Room/roomDissolutionApplication'), data, {
    method,
  }).then(data => {
    return formatData.formatListData(data);
  });
}

// 房间查询--房间申请审核
function roomApplicationReview(data, method) {
  return ajax('post', getRequestUrl('/api/Room/roomApplicationReview'), data, {
    method,
  });
}

// 房间查询--修改房间靓号
function roomNumberSet(data, method) {
  return ajax('post', getRequestUrl('/api/Room/roomNumberSet'), data, {
    method,
  });
}

// 房间查询--重置房间信息
function resetRoomInfo(data, method) {
  return ajax('post', getRequestUrl('/api/Room/resetRoomInfo'), data, {
    method,
  });
}
// 房间查询--背景快速审核
function quickAuditRoomBg(data, method) {
  return ajax('post', getRequestUrl('/api/Room/quickAuditRoomBg'), data, {
    method,
  });
}

// 申诉大厅列表
function getAppealHallList(data, method) {
  return ajax('post', getRequestUrl('/api/ComplainHall/findComplainListByPage'), data, {
    method,
  }).then(data => {
    return formatData.formatListData(data);
  });
}

// 左边菜单
function leftMenu(data, method) {
  return ajax('post', getRequestUrl('/api/Role/Menu'), data, {
    method,
  });
}

// 查看更多ip
function getMoreIp(data, method) {
  return ajax('post', getRequestUrl('/api/ComplainHall/findMoreIpListByPage'), data, {
    method,
  }).then(data => {
    return formatData.formatListData(data);
  });
}

// 申诉大厅 --- 选择封禁
function selectBlockId(data, method) {
  return ajax('post', getRequestUrl('/api/ComplainHall/selectBlockId'), data, {
    method,
  });
}
// 申诉大厅 --- 全部封禁
function allSelectBlockId(data, method) {
  return ajax('post', getRequestUrl('/api/ComplainHall/allBlockId'), data, {
    method,
  });
}
// 申诉大厅 -- 批量重置资料
function hallResetUserInfoBatch(data, method) {
  return ajax('post', getRequestUrl('/api/ComplainHall/resetUserInfoBatch'), data, {
    method,
  });
}

// 申诉大厅 -- 批量选择封禁设备
function hallBannedDeviceBatch(data, method) {
  return ajax('post', getRequestUrl('/api/ComplainHall/bannedDeviceBatch'), data, {
    method,
  });
}

// 机器举报列表
function getMReportList(data, method) {
  return ajax('post', getRequestUrl('/api/KeywordReport/findKeywordReportByPage'), data, {
    method,
  }).then(data => {
    return formatData.formatListData(data);
  });
}

// 机器举报列表查看详细内容
function getMReportContent(data, method) {
  return ajax('post', getRequestUrl('/api/KeywordReport/findReportContent'), data, {
    method,
  });
}

// 机器举报封禁
function bannedMReportId(data, method) {
  return ajax('post', getRequestUrl('/api/KeywordReport/bannedReportId'), data, {
    method,
  });
}

// 机器举报忽略
function ignoreMReport(data, method) {
  return ajax('post', getRequestUrl('/api/KeywordReport/ignoreReport'), data, {
    method,
  });
}

// 机器举报--批量重置资料接口
function machineResetUserInfoBatch(data, method) {
  return ajax('post', getRequestUrl('/api/KeywordReport/resetUserInfoBatch'), data, {
    method,
  });
}

// 机器举报--批量封禁id
function machineBannedIdBatch(data, method) {
  return ajax('post', getRequestUrl('/api/KeywordReport/bannedIdBatch'), data, {
    method,
  });
}

// 机器举报--批量选择封禁设备
function machineBannedDeviceBatch(data, method) {
  return ajax('post', getRequestUrl('/api/KeywordReport/bannedDeviceBatch'), data, {
    method,
  });
}

// 机器举报--批量忽略
function machineIgnoreReportBatch(data, method) {
  return ajax('post', getRequestUrl('/api/KeywordReport/ignoreReportBatch'), data, {
    method,
  });
}



// 用户举报列表
function getUReportList(data, method) {
  return ajax('post', getRequestUrl('/api/MemberReport/findMemberReportByPage'), data, {
    method,
  }).then(data => {
    return formatData.formatListData(data);
  });
}

// 用户封禁
function banedUser(data, method) {
  return ajax('post', getRequestUrl('/api/MemberReport/bannedId'), data, {
    method,
  });
}

// 用户举报--封禁房间
function banedRoom(data, method) {
  return ajax('post', getRequestUrl('/api/MemberReport/bannedRoom'), data, {
    method,
  });
}

// 用户举报--忽略举报
function userIgnoreReport(data, method) {
  return ajax('post', getRequestUrl('/api/MemberReport/ignoreReport'), data, {
    method,
  });
}

// 用户举报--删除举报
function userDeleteReport(data, method) {
  return ajax('post', getRequestUrl('/api/MemberReport/deleteReport'), data, {
    method,
  })
}

// 用户封禁解禁
function unbanedUser(data, method) {
  return ajax('post', getRequestUrl('/api/MemberReport/unBannedId'), data, {
    method,
  });
}

// 用户举报--解禁房间
function reportUnBannedRoom(data, method) {
  return ajax('post', getRequestUrl('/api/MemberReport/unBannedRoom'), data, {
    method,
  });
}

// 用户举报--封禁房间
function reportBannedRoom(data, method) {
  return ajax('post', getRequestUrl('/api/MemberReport/bannedRoom'), data, {
    method,
  });
}

// 用户举报--批量重置资料
function resetUserInfoBatch(data, method) {
  return ajax('post', getRequestUrl('/api/MemberReport/resetUserInfoBatch'), data, {
    method,
  });
}

// 用户举报--批量选择封禁id
function bannedIdBatch(data, method) {
  return ajax('post', getRequestUrl('/api/MemberReport/bannedIdBatch'), data, {
    method,
  });
}

// 用户举报--批量选择封禁设备
function bannedDeviceBatch(data, method) {
  return ajax('post', getRequestUrl('/api/MemberReport/bannedDeviceBatch'), data, {
    method,
  });
}

// 用户举报--发送警告信
function noticeUser(data, method) {
  return ajax('post', getRequestUrl('/api/Member/noticeUser'), data, {
    method,
  });
}

// 用户举报--批量忽略
function ignoreReportBatch(data, method) {
  return ajax('post', getRequestUrl('/api/MemberReport/ignoreReportBatch'), data, {
    method,
  });
}


// 区域请求
function regionSelectList(data, method) {
  return ajax('post', getRequestUrl('/api/CommonHelper/regionSelectList'), data, {
    method,
  });
}



// id申请列表
function getApplicationList(data, method) {
  return ajax('post', getRequestUrl('/api/Service/applyNoList'), data, {
    method,
  }).then(data => {
    return formatData.formatListData(data);
  });
}

// ID 兑换列表
function numberApplyList(data, method) {
  return ajax('post', getRequestUrl('/api/Service/numberApplyList'), data, {
    method,
  }).then(data => {
    return formatData.formatListData(data);
  });
}

// id申请--通过或拒绝审核
function changeApply(data, method) {
  return ajax('post', getRequestUrl('/api/Service/changeApply'), data, {
    method,
  });
}

// 背景管理--背景列表
function roomBgList(data, method) {
  return ajax('post', getRequestUrl('/api/Room/roomBgList'), data, {
    method,
  }).then(data => {
    return formatData.formatListData(data);
  });
}

// 背景管理--背景状态操作
function changeRoomBg(data, method) {
  return ajax('post', getRequestUrl('/api/Room/changeRoomBg'), data, {
    method,
  })
}

// 背景管理--批量背景操作
function changeRoomBgBatch(data, method) {
  return ajax('post', getRequestUrl('/api/Room/changeRoomBgBatch'), data, {
    method,
  })
}

// 活动申请--列表
function getRoomActiveList(data, method) {
  return ajax('post', getRequestUrl('/api/Room/roomActiveList'), data, {
    method,
  }).then(data => {
    return formatData.formatListData(data);
  });
}

// 活动申请--修改状态
function changeRoomActive(data, method) {
  return ajax('post', getRequestUrl('/api/Room/changeRoomActive'), data, {
    method,
  });
}

// 活动申请--删除活动
function deleteRoomActive(data, method) {
  return ajax('post', getRequestUrl('/api/Room/deleteRoomActive'), data, {
    method,
  });
}

// 活动申请--批量审核
function changeRoomActiveBatch(data, method) {
  return ajax('post', getRequestUrl('/api/Room/changeRoomActiveBatch'), data, {
    method,
  });
}

// 问题统计--问题统计列表
function servicekProblemList(data, method) {
  return ajax('post', getRequestUrl('/api/Service/servicekProblemList'), data, {
    method,
  }).then(data => {
    return formatData.formatListData(data);
  });
}

// 问题统计--问题详情
function findServicekProblem(data, method) {
  return ajax('post', getRequestUrl('/api/Service/findServicekProblem'), data, {
    method,
  });
}

// 问题统计--导出问题列表
// function servicekProblemListExport(data) {
//   return ajax('post', getRequestUrl('/api/Service/servicekProblemListExport'), data);
// }

// 客服问题统计--列表
function questionCountList(data, method) {
  return ajax('post', getRequestUrl('/api/Service/questionCountList'), data, {
    method,
  }).then(data => {
    return formatData.formatListData(data);
  });
}

// 操作日志列表
function serviceHistoryList(data, method) {
  return ajax('post', getRequestUrl('/api/Service/serviceHistoryList'), data, {
    method,
  }).then(data => {
    return formatData.formatListData(data);
  });
}
// CST工作统计
function customerServiceStatistics(data, method) {
  return ajax('post', getRequestUrl('/api/Service/customerServiceStatistics'), data, {
    method,
  }).then(data => {
    return formatData.formatListData(data);
  });
}


// OMT工作统计
function operateManagerStatistics(data, method) {
  return ajax('post', getRequestUrl('/api/Service/operateManagerStatistics'), data, {
    method,
  }).then(data => {
    return formatData.formatListData(data);
  });
}


// 客服知识库--列表
function servicekKnowledgeList(data, method) {
  return ajax('post', getRequestUrl('/api/Service/servicekKnowledgeList'), data, {
    method,
  }).then(data => {
    return formatData.formatListData(data);
  })
}

// 客服知识库--详情
function findServicekKnowledge(data, method) {
  return ajax('post', getRequestUrl('/api/Service/findServicekKnowledge'), data, {
    method,
  });
}

// 客服知识库--添加或更新
function saveServicekKnowledge(data, method) {
  return ajax('post', getRequestUrl('/api/Service/saveServicekKnowledge'), data, {
    method,
  });
}

// 客服知识库--更新
function updateServicekKnowledge(data, method) {
  return ajax('post', getRequestUrl('/api/Service/updateServicekKnowledge'), data, {
    method,
  });
}

// 客服知识库--删除
function deleteServicekKnowledge(data, method) {
  return ajax('post', getRequestUrl('/api/Service/deleteServicekKnowledge'), data, {
    method,
  });
}

// 客服账号管理--列表
function managementList(data, method) {
  return ajax('post', getRequestUrl('/api/ServiceManagement/findServiceManagementByPage'), data, {
    method,
  }).then(data => {
    return formatData.formatListData(data);
  });
}

// 客服账号管理--客服详情
function managementDetail(data, method) {
  return ajax('post', getRequestUrl('/api/ServiceManagement/languageInfo'), data, {
    method,
  });
}

// 客服账号管理--保存客服信息
function managementSave(data, method) {
  return ajax('post', getRequestUrl('/api/ServiceManagement/saveSevice'), data, {
    method,
  });
}

// 客服账号管理--删除客服
function managementListDelete(data, method) {
  return ajax('post', getRequestUrl('/api/ServiceManagement/deleteSevice'), data, {
    method,
  });
}

// 家族查询--列表
function familyList(data, method) {
  return ajax('post', getRequestUrl('/api/Family/findFamilyList'), data, {
    method,
  });
}

// 家族查询--家族成员列表
function familyMemberList(data, method) {
  return ajax('post', getRequestUrl('/api/Family/findFamilyMemberByPage'), data, {
    method,
  }).then(data => {
    return formatData.formatListData(data);
  });
}

// 家族查询--删除家族某成员
function familyMenberDelete(data, method) {
  return ajax('post', getRequestUrl('/api/Family/deleteFromFamily'), data, {
    method,
  });
}

// 家族查询--修改家族名称
function familyNameSave(data, method) {
  return ajax('post', getRequestUrl('/api/Family/saveFamilyName'), data, {
    method,
  });
}

// 家族查询--修改家族头像接口
function familyAvatarSave(data, method) {
  return ajax('post', getRequestUrl('/api/Family/saveFamilyAvatar'), data, {
    method,
  });
}

// 家族查询--家族详情
function familyDetail(data, method) {
  return ajax('post', getRequestUrl('/api/Family/findFamily'), data, {
    method,
  });
}

// 家族查询--解散家族
function deleteFamily(data, method) {
  return ajax('post', getRequestUrl('/api/Family/deleteFamily'), data, {
    method,
  })
}

// 家族查询--家族解散申请列表
function familyDissolutionApplication(data, method) {
  return ajax('post', getRequestUrl('/api/Family/familyDissolutionApplication'), data, {
    method,
  }).then(data => {
    return formatData.formatListData(data);
  });
}

// 家族查询--家族解散申请审核
function familyApplicationReview(data, method) {
  return ajax('post', getRequestUrl('/api/Family/familyApplicationReview'), data, {
    method,
  })
}

// 家族查询--重置家族信息
function familyResetFamily(data, method) {
  return ajax('post', getRequestUrl('/api/Family/familyResetFamily'), data, {
    method,
  })
}

// 管理员管理--管理员列表
function accountList(data, method) {
  return ajax('post', getRequestUrl('/api/Admin/adminList'), data, {
    method,
  }).then(data => {
    return formatData.formatListData(data);
  });
}

// 管理员管理--管理员信息
function findAdmin(data, method) {
  return ajax('post', getRequestUrl('/api/Admin/findAdmin'),data, {
    method,
  });
}

// 管理员管理--创建管理员
function createAdmin(data, method) {
  return ajax('post', getRequestUrl('/api/Admin/createAdmin'), data, {
    method,
  });
}

// 管理员管理--更新管理员
function updateAdmin(data, method) {
  return ajax('post', getRequestUrl('/api/Admin/updateAdmin'), data, {
    method,
  });
}

// 管理员管理--删除管理员
function deleteAdmin(data, method) {
  return ajax('post', getRequestUrl('/api/Admin/deleteAdmin'), data, {
    method,
  });
}

// 管理员管理--修改管理员状态
function changeAdminStatus(data, method) {
  return ajax('post', getRequestUrl('/api/Admin/changeAdminStatus'), data, {
    method,
  });
}

// 管理员管理--选择角色列表
function adminRolesList(data, method) {
  return ajax('post', getRequestUrl('/api/Admin/rolesList'), data, {
    method,
  });
}

// 角色管理--角色列表
function roleList(data, method) {
  return ajax('post', getRequestUrl('/api/Role/roleList'), data, {
    method,
  }).then(data => {
    return formatData.formatListData(data);
  });
}

// 角色管理--角色详情
function findRole(data, method) {
  return ajax('post', getRequestUrl('/api/Role/findRole'), data, {
    method,
  });
}

// 角色管理--创建角色
function createRole(data, method) {
  return ajax('post', getRequestUrl('/api/Role/createRole'), data, {
    method,
  });
}

// 角色管理--更新角色
function updateRole(data, method) {
  return ajax('post', getRequestUrl('/api/Role/updateRole'), data, {
    method,
  });
}

// 角色管理--分配权限
function assignRolePower(data, method) {
  return ajax('post', getRequestUrl('/api/Role/assignRolePower'), data, {
    method,
  });
}

// 节点管理--节点列表
function powerList(data, method) {
  return ajax('post', getRequestUrl('/api/Power/powerList'), data, {
    method,
  });
}

// 节点管理--节点详情
function findPower(data, method) {
  return ajax('post', getRequestUrl('/api/Power/findPower'), data, {
    method,
  });
}

// 节点管理--创建节点
function createPower(data, method) {
  return ajax('post', getRequestUrl('/api/Power/createPower'), data, {
    method,
  });
}

// 节点管理--更新节点
function updatePower(data, method) {
  return ajax('post', getRequestUrl('/api/Power/updatePower'), data, {
    method,
  });
}

// 节点管理--三级权限列表
function unlimitPowerList(data, method) {
  return ajax('post', getRequestUrl('/api/Power/unlimitPowerList'), data, {
    method,
  });
}

// 超级管理员--列表
function findSupermanList(data, method) {
  return ajax('post', getRequestUrl('/api/Administrator/findSupermanList'), data, {
    method,
  }).then(data => {
    return formatData.formatListData(data);
  });;
}

// 超级管理员--国家列表
function findCountryAdminList(data, method) {
  return ajax('post', getRequestUrl('/api/Administrator/findCountryAdminList'), data, {
    method,
  }).then(data => {
    return formatData.formatListData(data);
  });
}

// 超级管理员--修改超管所属分组
function updateAdminGroup(data, method) {
  return ajax('post', getRequestUrl('/api/Administrator/updateAdminGroup'), data, {
    method,
  })
}

// 超级管理员--分组列表
function adminGroupList(data, method) {
  return ajax('post', getRequestUrl('/api/Administrator/adminGroupList'), data, {
    method,
  }).then(data => {
    return formatData.formatListData(data);
  });
}

// 超级管理员--保存分组信息
function adminGroupSave(data, method) {
  return ajax('post', getRequestUrl('/api/Administrator/adminGroupSave'), data, {
    method,
  })
}

// 超级管理员--删除管理员分组
function adminGroupDelete(data, method) {
  return ajax('post', getRequestUrl('/api/Administrator/adminGroupDelete'), data, {
    method,
  })
}

// 问题库--列表
function findQuestionBankList(data, method) {
  return ajax('post', getRequestUrl('/api/QuestionBank/findQuestionBankList'), data, {
    method,
  }).then(data => {
    return formatData.formatListData(data);
  })
}

// 问题库--问题详情
function questionBankDetail(data, method) {
  return ajax('post', getRequestUrl('/api/QuestionBank/findQuestionBank'), data, {
    method,
  });
}

// 问题库--保存问题信息（修改或添加）
function saveQuestionBank(data, method) {
  return ajax('post', getRequestUrl('/api/QuestionBank/saveQuestionBank'), data, {
    method,
  });
}

// 问题库--删除问题
function deleteQuestionBank(data, method) {
  return ajax('post', getRequestUrl('/api/QuestionBank/deleteQuestionBank'), data, {
    method,
  });
}
// 问题库--批量导入知识库
function saveQuestionBankByExcel(data, method) {
  return uploadImg(getRequestUrl('/api/QuestionBank/saveQuestionBankByExcel'), data)
}

// 丢单信息查询--列表
function findLostOrderByPage(data, method) {
  return ajax('post', getRequestUrl('/api/LostOrder/findLostOrderByPage'), data, {
    method,
  }).then(data => {
    return formatData.formatListData(data);
  });
}

// 话题管理--列表
function findSnsTopicByPage(data, method) {
  return ajax('post', getRequestUrl('/api/SnsManage/findSnsTopicByPage'), data, {
    method,
  }).then(data => {
    return formatData.formatListData(data);
  });
}
// 话题管理--删除评论帖子
function deleteCommentOrPost(data, method) {
  return ajax('post', getRequestUrl('/api/SnsManage/deleteCommentOrPost'), data, {
    method,
  });
}
// 话题管理--详情
function findSnsDetail(data, method) {
  return ajax('post', getRequestUrl('/api/SnsManage/findSnsDetail'), data, {
    method,
  });
}
// 话题管理--添加话题
function saveSnsTopic(data, method) {
  return ajax('post', getRequestUrl('/api/SnsManage/saveSnsTopic'), data, {
    method,
  });
}
// 话题管理--上下架
function updateRack(data, method) {
  return ajax('post', getRequestUrl('/api/SnsManage/updateRack'), data, {
    method,
  });
}

// 话题管理--编辑话题管理员接口
function setSnsTopicAdmin(data, method) {
  return ajax('post', getRequestUrl('/api/SnsManage/setSnsTopicAdmin'), data, {
    method,
  });
}

// 话题管理--话题管理员列表
function snsTopicAdminList(data, method) {
  return ajax('post', getRequestUrl('/api/SnsManage/snsTopicAdminList'), data, {
    method,
  });
}

// 话题管理--话题分类列表
function cateList(data, method) {
  return ajax('post', getRequestUrl('/api/SnsManage/cateList'), data, {
    method,
  }).then(data => {
    return formatData.formatListData(data);
  })
}

// 话题管理--设置话题分类
function setTopicCate(data, method) {
  return ajax('post', getRequestUrl('/api/SnsManage/setTopicCate'), data, {
    method,
  });
}

// 话题管理--话题分类列表 (弹窗的)
function topicCateList(data, method) {
  return ajax('post', getRequestUrl('/api/SnsManage/topicCateList'), data, {
    method,
  }).then(data => {
    return formatData.formatListData(data);
  })
}

// 话题管理--添加/修改分类
function addtopicCate(data, method) {
  return ajax('post', getRequestUrl('/api/SnsManage/addtopicCate'), data, {
    method,
  });
}

// 话题管理--上下架分类
function isOntopicCate(data, method) {
  return ajax('post', getRequestUrl('/api/SnsManage/isOntopicCate'), data, {
    method,
  });
}

// 话题审核--列表
function topicReviewList(data, method) {
  return ajax('post', getRequestUrl('/api/SnsManage/topicReviewList'), data, {
    method,
  }).then(data => {
    return formatData.formatListData(data);
  });
}

// 话题管理--话题审核操作
function reviewOperation(data, method) {
  return ajax('post', getRequestUrl('/api/SnsManage/reviewOperation'), data, {
    method,
  });
}

// 帖子管理--帖子列表
function findSnsPostByPage(data, method) {
  return ajax('post', getRequestUrl('/api/SnsManage/findSnsPostByPage'), data, {
    method,
  }).then(data => {
    return formatData.formatListData(data);
  })
}

// 帖子管理--推荐帖子
function recommendSnsPost(data, method) {
  return ajax('post', getRequestUrl('/api/SnsManage/recommendSnsPost'), data, {
    method,
  })
}

// 帖子管理--审核帖子
function statusSnsPost(data, method) {
  return ajax('post', getRequestUrl('/api/SnsManage/statusSnsPost'), data, {
    method,
  })
}

// 帖子管理--沉帖
function dropSnsPost(data, method) {
  return ajax('post', getRequestUrl('/api/SnsManage/dropSnsPost'), data, {
    method,
  })
}

// 帖子管理--屏蔽帖子
function screenSnsPost(data, method) {
  return ajax('post', getRequestUrl('/api/SnsManage/screenSnsPost'), data, {
    method,
  })
}

// 帖子管理--取消屏蔽
function cancelScreen(data, method) {
  return ajax('post', getRequestUrl('/api/SnsManage/cancelScreen'), data, {
    method,
  })
}

// 帖子管理--删除帖子
function deleteSnsPost(data, method) {
  return ajax('post', getRequestUrl('/api/SnsManage/deleteSnsPost'), data, {
    method,
  })
}

// 帖子管理--置顶帖子接口
function setPostTop(data, method) {
  return ajax('post', getRequestUrl('/api/SnsManage/setPostTop'), data, {
    method,
  })
}

// 帖子管理--取消置顶帖子接口
function cancelPostTop(data, method) {
  return ajax('post', getRequestUrl('/api/SnsManage/cancelPostTop'), data, {
    method,
  })
}

// 举报管理--列表
function findSnsMemberActionByPage(data, method) {
  return ajax('post', getRequestUrl('/api/SnsManage/findSnsMemberActionByPage'), data, {
    method,
  }).then(data => {
    return formatData.formatListData(data);
  });
}

// 举报管理--举报操作
function reportOperation(data, method) {
  return ajax('post', getRequestUrl('/api/SnsManage/reportOperation'), data, {
    method,
  }).then(data => {
    return formatData.formatListData(data);
  });
}

// 举报管理--熔断数据列表
function reportSnsMonitorRecord(data, method) {
  return ajax('post', getRequestUrl('/api/SnsManage/snsFusingRecord'), data, {
    method,
  }).then(data => {
    return formatData.formatListData(data);
  });
}

// 举报管理--忽略举报信息
function ignoreMemberAction(data, method) {
  return ajax('post', getRequestUrl('/api/SnsManage/ignoreMemberAction'), data, {
    method,
  })
}

// 举报管理--屏蔽举报
function screenMemberAction(data, method) {
  return ajax('post', getRequestUrl('/api/SnsManage/screenMemberAction'), data, {
    method,
  })
}

// 举报管理--禁言
function muteMember(data, method) {
  return ajax('post', getRequestUrl('/api/SnsManage/muteMember'), data, {
    method,
  })
}

// 举报管理--解除禁言
function unbanMute(data, method) {
  return ajax('post', getRequestUrl('/api/SnsManage/unbanMute'), data, {
    method,
  })
}

// 举报管理--删除举报
function deleteMemberAction(data, method) {
  return ajax('post', getRequestUrl('/api/SnsManage/deleteMemberAction'), data, {
    method,
  })
}

// 举报管理--忽略熔断信息接口
function snsFusingIgnore(data, method) {
  return ajax('post', getRequestUrl('/api/SnsManage/snsFusingIgnore'), data, {
    method,
  })
}

// 举报管理--删除熔断信息接口
function snsFusingDelete(data, method) {
  return ajax('post', getRequestUrl('/api/SnsManage/snsFusingDelete'), data, {
    method,
  })
}

// 帖子权限设置
function setCreatePostPower(data, method) {
  return ajax('post', getRequestUrl('/api/SnsManage/setCreatePostPower'), data, {
    method,
  })
}

// 当前帖子权限规则接口
function findCreatePostPower(data, method) {
  return ajax('post', getRequestUrl('/api/SnsManage/findCreatePostPower'), data, {
    method,
  })
}

// 审核人员管理--列表
function findSnsAuditorByPage(data, method) {
  return ajax('post', getRequestUrl('/api/SnsManage/findSnsAuditorByPage'), data, {
    method,
  }).then(data => {
    return formatData.formatListData(data);
  });
}

// 审核人员管理--审核人员详情
function auditFindSnsDetail(data, method) {
  return ajax('post', getRequestUrl('/api/SnsManage/findSnsAuditorDetail'), data, {
    method,
  })
}

// 审核人员管理--保存审核人员信息
function saveSnsAuditor(data, method) {
  return ajax('post', getRequestUrl('/api/SnsManage/saveSnsAuditor'), data, {
    method,
  })
}
// 审核人员管理--删除审核人员信息
function deleteSnsAuditor(data, method) {
  return ajax('post', getRequestUrl('/api/SnsManage/deleteSnsAuditor'), data, {
    method,
  })
}
// 审核人员管理--审核统计
function statisticsSnsAuditorOperate(data, method) {
  return ajax('post', getRequestUrl('/api/SnsManage/statisticsSnsAuditorOperate'), data, {
    method,
  }).then(data => {
    return formatData.formatListData(data);
  });
}

// 社区异常操作上报--列表
function anomalySnsMonitorRecord(data, method) {
  return ajax('post', getRequestUrl('/api/SnsManage/snsMonitorRecord'), data, {
    method,
  }).then(data => {
    return formatData.formatListData(data);
  });
}

// 社区异常操作上报--批量选择封禁
function anomalyBannedIdBatch(data, method) {
  return ajax('post', getRequestUrl('/api/SnsManage/bannedIdBatch'), data, {
    method,
  })
}

// 社区异常操作上报--批量选择封禁设备
function anomalyBannedDeviceBatch(data, method) {
  return ajax('post', getRequestUrl('/api/SnsManage/bannedDeviceBatch'), data, {
    method,
  })
}

// 社区异常操作上报--批量忽略
function anomalyIgnoreReportBatch(data, method) {
  return ajax('post', getRequestUrl('/api/SnsManage/ignoreReportBatch'), data, {
    method,
  })
}

// 社区异常操作上报--查看评论列表
function anomalyContentList(data, method) {
  return ajax('post', getRequestUrl('/api/SnsManage/contentList'), data, {
    method,
  })
}

// 社区异常操作上报--删除评论
function anomalyDeleteContent(data, method) {
  return ajax('post', getRequestUrl('/api/SnsManage/deleteContent'), data, {
    method,
  })
}

// 社区异常操作上报--封禁记录
function anomalySnsMonitorBanIdRecord(data, method) {
  return ajax('post', getRequestUrl('/api/SnsManage/snsMonitorBanIdRecord'), data, {
    method,
  }).then(data => {
    return formatData.formatListData(data);
  });
}

// 社区异常操作上报--批量重置资料
function anomalyRsetUserInfoBatch(data, method) {
  return ajax('post', getRequestUrl('/api/SnsManage/resetUserInfoBatch'), data, {
    method,
  })
}

// 社区日常统计--社区内容统计
function findSnsSummarContent(data, method) {
  return ajax('post', getRequestUrl('/api/SnsSummary/findSnsSummarContent'), data, {
    method,
  }).then(data => {
    return formatData.formatListData(data);
  });
}

// 社区日常统计--社区用户行为统计
function findSnsSummarAction(data, method) {
  return ajax('post', getRequestUrl('/api/SnsSummary/findSnsSummarAction'), data, {
    method,
  }).then(data => {
    return formatData.formatListData(data);
  });
}

// 社区互动帖子统计
function findSnsSummarActive(data, method) {
  return ajax('post', getRequestUrl('/api/SnsSummary/findSnsSummarActive'), data, {
    method,
  }).then(data => {
    return formatData.formatListData(data);
  });
}

// 社区--移贴列表
function findSnsMovePostByPage(data, method) {
  return ajax('post', getRequestUrl('/api/SnsManage/findSnsMovePostByPage'), data, {
    method,
  }).then(data => {
    return formatData.formatListData(data);
  });
}

// 社区--根据分区获取联动话题接口
function findSnsTopicByRegion(data, method) {
  return ajax('post', getRequestUrl('/api/SnsManage/findSnsTopicByRegion'), data, {
    method,
  })
}

// 社区--移帖操作
function movePostByTopic(data, method) {
  return ajax('post', getRequestUrl('/api/SnsManage/movePostByTopic'), data, {
    method,
  })
}

// 社区 -- 年度盛典 -- 帖子列表
function selectPostList(data, method) {
  return ajax('post', getRequestUrl('/api/SnsManage/selectPostList'), data, {
    method,
  }).then(data => {
    return formatData.formatListData(data);
  });
}

// 社区 -- 年度盛典 -- 单条帖子的信息
function findSelectPost(data, method) {
  return ajax('post', getRequestUrl('/api/SnsManage/findSelectPost'), data, {
    method,
  })
}

// 社区 -- 年度盛典 -- 帖子添加或修改
function saveSelectPost(data, method) {
  return ajax('post', getRequestUrl('/api/SnsManage/saveSelectPost'), data, {
    method,
  })
}

// 社区 -- 年度盛典 -- 删除帖子
function deleteSelectPost(data, method) {
  return ajax('post', getRequestUrl('/api/SnsManage/deleteSelectPost'), data, {
    method,
  })
}

// 头像审核--头像审核列表
function applyAvatarByList(data, method) {
  return ajax('post', getRequestUrl('/api/MemberAvatar/applyAvatarByList'), data, {
    method,
  }).then(data => {
    return formatData.formatListData(data);
  });
}

// 头像审核--批量重置资料
function avatarResetUserInfoBatch(data, method) {
  return ajax('post', getRequestUrl('/api/MemberAvatar/resetUserInfoBatch'), data, {
    method,
  })
}

// 头像审核--批量选择封禁id
function avatarBannedIdBatch(data, method) {
  return ajax('post', getRequestUrl('/api/MemberAvatar/bannedIdBatch'), data, {
    method,
  })
}

// 头像审核--批量选择封禁设备
function avatarBannedDeviceBatch(data, method) {
  return ajax('post', getRequestUrl('/api/MemberAvatar/bannedDeviceBatch'), data, {
    method,
  })
}

// 头像审核--批量忽略
function avatarPassAvatarBatch(data, method) {
  return ajax('post', getRequestUrl('/api/MemberAvatar/passAvatarBatch'), data, {
    method,
  })
}

// 头像审核--批量忽略
function quickAuditAvatar(data, method) {
  return ajax('post', getRequestUrl('/api/MemberAvatar/quickAuditAvatar'), data, {
    method,
  })
}

// 图片审核--列表
function userAlbumList(data, method) {
  return ajax('post', getRequestUrl('/api/Member/userAlbumList'), data, {
    method,
  }).then(data => {
    return formatData.formatListData(data);
  });
}

// 图片审核--相册审核
function userAlbumBatch(data, method) {
  return ajax('post', getRequestUrl('/api/Member/userAlbumBatch'), data, {
    method,
  }).then(data => {
    return formatData.formatListData(data);
  });
}

// 图片审核--相册快速审核
function quickAuditAlbum(data, method) {
  return ajax('post', getRequestUrl('/api/Member/quickAuditAlbum'), data, {
    method,
  }).then(data => {
    return formatData.formatListData(data);
  });
}

// 广播管理--广播管理列表
function broadcastList(data, method) {
  return ajax('post', getRequestUrl('/api/Broadcast/broadcastByList'), data, {
    method,
  }).then(data => {
    return formatData.formatListData(data);
  });
}

// 广播管理--禁止发广播12h
function bannedBroadcastsBatch(data, method) {
  return ajax('post', getRequestUrl('/api/Broadcast/bannedBroadcastsBatch'), data, {
    method,
  })
}

// 广播管理--批量忽略
function broadIgnoreBatch(data, method) {
  return ajax('post', getRequestUrl('/api/Broadcast/ignoreBatch'), data, {
    method,
  })
}

// 广播管理--批量删除
function broadDeleteBatch(data, method) {
  return ajax('post', getRequestUrl('/api/Broadcast/deleteBatch'), data, {
    method,
  })
}

// 广播管理--批量选择封禁id
function broadBanId(data, method) {
  return ajax('post', getRequestUrl('/api/Broadcast/bannedIdBatch'), data, {
    method,
  })
}

// 广播管理--批量选择封禁设备
function broadBanDevice(data, method) {
  return ajax('post', getRequestUrl('/api/Broadcast/bannedDeviceBatch'), data, {
    method,
  })
}

// 广播管理--批量召集审核
function setBatchConvent(data, method) {
  return ajax('post', getRequestUrl('/api/Broadcast/setBatchConvent'), data, {
    method,
  })
}

// 广播管理--快速审核
function quickAuditBroadcasts(data, method) {
  return ajax('post', getRequestUrl('/api/Broadcast/quickAuditBroadcasts'), data, {
    method,
  })
}
// 广播管理--召集快速审核
function quickAuditConvene(data, method) {
  return ajax('post', getRequestUrl('/api/Broadcast/quickAuditConvene'), data, {
    method,
  })
}

// 登录反馈列表
function loginFeedbackList(data, method) {
  return ajax('post', getRequestUrl('/api/Service/loginFeedbackList'), data, {
    method,
  }).then(data => {
    return formatData.formatListData(data);
  });
}

// 登陆反馈详情
function loginFeedbackInfo(data, method) {
  return ajax('post', getRequestUrl('/api/Service/loginFeedbackInfo'), data, {
    method,
  })
}

// 批量关闭问题
function closeServicekProblem(data, method) {
  return ajax('post', getRequestUrl('/api/Service/closeServicekProblem'), data, {
    method,
  })
}
// 批量回复问题
function replyServicekProblem(data, method) {
  return ajax('post', getRequestUrl('/api/Service/replyServicekProblem'), data, {
    method,
  })
}

// 黑名单 -- 账号黑名单
function blackIpList(data, method) {
  return ajax('post', getRequestUrl('/api/BlacklistManagement/blackIpList'), data, {
    method,
  }).then(data => {
    return formatData.formatListData(data);
  });
}

// 黑名单 -- 增加删除黑名单
function operateBlackIp(data, method) {
  return ajax('post', getRequestUrl('/api/BlacklistManagement/operateBlackIp'), data, {
    method,
  })
}

// 黑名单 -- 拒绝服务日志
function blackIpRecordList(data, method) {
  return ajax('post', getRequestUrl('/api/BlacklistManagement/blackIpRecordList'), data, {
    method,
  }).then(data => {
    return formatData.formatListData(data);
  });
}

// 黑名单 -- 异常注册情况
function exceptionRegistrationList(data, method) {
  return ajax('post', getRequestUrl('/api/BlacklistManagement/exceptionRegistrationList'), data, {
    method,
  }).then(data => {
    return formatData.formatListData(data);
  });
}

// 活动扶持统计
function activityPoorByPage(data, method) {
  return ajax('post', getRequestUrl('/api/DataPoor/activityPoorByPage'), data, {
    method,
  }).then(data => {
    return formatData.formatListData(data);
  });
}

// 国家列表
function findCountryList(data, method) {
  return ajax('post', getRequestUrl('/api/CommonHelper/findCountryList'), data, {
    method,
  })
}

// 国家列表
function systemcountrylist(data, method) {
  return ajax('post', getRequestUrl('/api/member/systemcountrylist'), data, {
    method,
  })
}

// couple 活动 列表
function getCoupleLinkList(data, method) {
  return ajax('post', getRequestUrl('/api/Couple/getCoupleLinkList'), data, {
    method,
  }).then(data => {
    return formatData.formatListData(data);
  });
}

// couple 获取某个活动
function getCoupleLinkById(data, method) {
  return ajax('post', getRequestUrl('/api/Couple/getCoupleLinkById'), data, {
    method,
  })
}

// couple 删除某个活动
function delCoupleLinkById(data, method) {
  return ajax('post', getRequestUrl('/api/Couple/delCoupleLinkById'), data, {
    method,
  })
}

// couple 新增某个活动
function addCoupleLink(data, method) {
  return ajax('post', getRequestUrl('/api/Couple/addCoupleLink'), data, {
    method,
  })
}

// 管理员管理--运营对应模块详细权限列表

function usersPowerUidModule(data, method) {
  return ajax('post', getRequestUrl('/api/Admin/usersPowerUidModule'), data, {
    method,
  });
}
// 管理员管理--运营对模块权限设置
function usersPowerUidModuleSet(data, method) {
  return ajax('post', getRequestUrl('/api/Admin/usersPowerUidModuleSet'), data, {
    method,
  });
}

// 管理员管理--道具发放限制列表
function propSendLimitList(data, method) {
  return ajax('post', getRequestUrl('/api/Admin/propSendLimitList'), data, {
    method,
  });
}
// 管理员管理--道具发放限制添加/编辑
function propSendLimitSet(data, method) {
  return ajax('post', getRequestUrl('/api/Admin/propSendLimitSet'), data, {
    method,
  });
}
// 用户查询 -- 修改会员资金状态
function userFreezeMember(data, method) {
  return ajax('post', getRequestUrl('/api/Member/freezeMember'), data, {
    method,
  });
}

// 用户查询--修改性别接口
function updateSex(data, method) {
  return ajax('post', getRequestUrl('/api/Member/updateSex'), data, {
    method,
  });
}



// 群组审核 -- 头像审核- 头像审核列表
function GroupReviewList(data) {
  return ajax('post', getRequestUrl('/api/GroupChat/GroupReviewList'), data)
}

// 群组审核 -- 头像审核- 头像审核通过
function faceUrlReview(data) {
  return ajax('post', getRequestUrl('/api/GroupChat/faceUrlReview'), data)
}

// 群组审核 -- 头像审核- 批量重置群资料
function resetGroupInformation(data) {
  return ajax('post', getRequestUrl('/api/GroupChat/reviewResetGroup'), data)
}

// 群组审核 -- 批量封禁群组
function groupBan(data) {
  return ajax('post', getRequestUrl('/api/GroupChat/groupBan'), data)
}
// 群组审核 -- 批量封禁群主
function bannedIdBatchGroup(data) {
  return ajax('post', getRequestUrl('/api/GroupChat/bannedIdBatch'), data)
}

// 群组审核 -- 举报审核列表
function GroupFeedbackList(data) {
  return ajax('post', getRequestUrl('/api/GroupChat/GroupFeedbackList'), data)
}

// 群组审核 -- 批量通过群举报
function feedbackReview(data) {
  return ajax('post', getRequestUrl('/api/GroupChat/feedbackReview'), data)
}


// 帖子审核 -- 禁止发帖
function snsBannedUser(data) {
  return ajax('post', getRequestUrl('/api/SnsManage/snsBannedUser'), data)
}



export default {
  quickAuditRoomBg,
  closeServicekProblem,
  replyServicekProblem,
  quickAuditAlbum,
  quickAuditAvatar,
  quickAuditBroadcasts,
  quickAuditConvene,
  userFreezeMember,
  repayment,
  remarkSet,
  deleteCommentOrPost,
  propSendLimitList,
  propSendLimitSet,
  usersPowerUidModule,
  usersPowerUidModuleSet,
  systemcountrylist,
  login: login,
  loginOut,
  checkAdminPwd,
  checkOperateUser,
  exportData: exportData,
  exportExtData,
  upload: upload,
  uploadVideo,
  api_room,
  saveRoomName,
  unBannedRoom,
  saveRoomAvatar,
  bannedRoom,
  leftMenu,
  usersSearch,
  memberMoreIp,

  memberBannedId,
  memberBannedDevice,
  memberNoBannedDevice,
  memberUnBannedId,
  memberFindPropList,
  memberCreateProp,
  memberCreateVip,
  memberDeleteHoldProp,
  BannedSvipList,
  selectBlockIdAndDevice,
  gatherBan,
  gatherUnblock,
  freezeRechargeList,
  getbanAccountList,
  uidMemoList,
  uidMemoAdd,
  deleteBackpackProp,
  memberBannedBroadcast,
  memberMorePushId,
  userUnbanBroadcast,
  saveCountry,
  systemCountryList,
  specialList,
  nowMemberInroom,
  memberHistoryList,
  savePassword,
  saveMobile,
  editRegion,
  saveEmail,
  userUnbind,
  resetUserInfo,
  noticeUser,
  updateSex,

  saveUserNo,
  saveNickname,
  saveAvatar,
  roomBlackList,
  removeRoomBlack,
  roomDissolutionApplication,
  roomApplicationReview,
  roomNumberSet,
  resetRoomInfo,
  getAppealHallList,
  getMoreIp,
  selectBlockId,
  allSelectBlockId,
  hallResetUserInfoBatch,
  hallBannedDeviceBatch,
  getMReportList,
  getUReportList,
  banedUser,
  banedRoom,
  userIgnoreReport,
  userDeleteReport,
  unbanedUser,
  reportUnBannedRoom,
  reportBannedRoom,
  resetUserInfoBatch,
  bannedIdBatch,
  bannedDeviceBatch,
  ignoreReportBatch,
  getMReportContent,
  bannedMReportId,
  ignoreMReport,
  machineResetUserInfoBatch,
  machineBannedIdBatch,
  machineBannedDeviceBatch,
  machineIgnoreReportBatch,
  getApplicationList,
  numberApplyList,
  changeApply,
  roomBgList,
  changeRoomBg,
  changeRoomBgBatch,
  getRoomActiveList,
  changeRoomActive,
  deleteRoomActive,
  changeRoomActiveBatch,
  servicekProblemList,
  findServicekProblem,
  // servicekProblemListExport,
  questionCountList,
  serviceHistoryList,
  customerServiceStatistics,
  operateManagerStatistics,
  servicekKnowledgeList,
  findServicekKnowledge,
  saveServicekKnowledge,
  updateServicekKnowledge,
  deleteServicekKnowledge,
  managementList,
  managementDetail,
  managementSave,
  managementListDelete,

  familyList,
  familyMemberList,
  familyMenberDelete,
  familyNameSave,
  familyAvatarSave,
  familyDetail,
  deleteFamily,
  familyDissolutionApplication,
  familyApplicationReview,
  familyResetFamily,
  accountList,
  findAdmin,
  createAdmin,
  updateAdmin,
  deleteAdmin,
  changeAdminStatus,
  adminRolesList,

  roleList,
  findRole,
  createRole,
  updateRole,
  assignRolePower,
  powerList,
  findPower,
  createPower,
  updatePower,
  unlimitPowerList,
  findSupermanList,
  findCountryAdminList,
  updateAdminGroup,
  adminGroupList,
  adminGroupSave,
  adminGroupDelete,
  findQuestionBankList,
  questionBankDetail,
  saveQuestionBank,
  deleteQuestionBank,
  saveQuestionBankByExcel,
  findLostOrderByPage,

  findSnsTopicByPage,
  findSnsDetail,
  saveSnsTopic,
  updateRack,
  setSnsTopicAdmin,
  snsTopicAdminList,
  cateList,
  setTopicCate,
  topicCateList,
  addtopicCate,
  isOntopicCate,
  topicReviewList,
  reviewOperation,
  findSnsPostByPage,
  recommendSnsPost,
  statusSnsPost,
  dropSnsPost,
  screenSnsPost,
  cancelScreen,
  deleteSnsPost,
  setPostTop,
  cancelPostTop,
  findSnsMemberActionByPage,
  reportOperation,
  reportSnsMonitorRecord,
  ignoreMemberAction,
  screenMemberAction,
  muteMember,
  unbanMute,
  deleteMemberAction,
  snsFusingIgnore,
  snsFusingDelete,
  setCreatePostPower,
  findCreatePostPower,
  findSnsAuditorByPage,
  auditFindSnsDetail,
  saveSnsAuditor,
  deleteSnsAuditor,
  statisticsSnsAuditorOperate,
  anomalySnsMonitorRecord,
  anomalyBannedIdBatch,
  anomalyBannedDeviceBatch,
  anomalyIgnoreReportBatch,
  anomalyContentList,
  anomalyDeleteContent,
  anomalySnsMonitorBanIdRecord,
  anomalyRsetUserInfoBatch,
  findSnsSummarContent,
  findSnsSummarAction,
  findSnsSummarActive,
  findSnsMovePostByPage,
  findSnsTopicByRegion,
  movePostByTopic,
  selectPostList,
  findSelectPost,
  saveSelectPost,
  deleteSelectPost,
  applyAvatarByList,
  avatarResetUserInfoBatch,
  avatarBannedIdBatch,
  avatarBannedDeviceBatch,
  avatarPassAvatarBatch,
  userAlbumList,
  userAlbumBatch,
  broadcastList,
  bannedBroadcastsBatch,
  broadIgnoreBatch,
  broadDeleteBatch,
  broadBanId,
  broadBanDevice,
  setBatchConvent,
  loginFeedbackList,
  loginFeedbackInfo,
  blackIpList,
  operateBlackIp,
  blackIpRecordList,
  exceptionRegistrationList,
  activityPoorByPage,
  findCountryList,
  getCoupleLinkList,
  getCoupleLinkById,
  delCoupleLinkById,
  addCoupleLink,
  refundDetailsList,
  regionSelectList,

  GroupReviewList,
  faceUrlReview,
  resetGroupInformation,
  groupBan,
  bannedIdBatchGroup,
  GroupFeedbackList,
  feedbackReview,

  ...roomColumn,

  snsBannedUser,
  ...group,
  UnblockInformation,
}



// WEBPACK FOOTER //
// ./src/js/http.js